/**
 * Semántica de expires_at con fecha sin hora (YYYY-MM-DD):
 * se interpreta como medianoche local del día indicado (00:00:00).
 * El pop-up NO se muestra en ese día; el último día visible es el anterior.
 *
 * Ejemplo: "2025-06-15" → visible todo el 14, no visible desde las 00:00 del 15.
 */

/** Parsea YYYY-MM-DD (o ISO) como medianoche local del día indicado. */
export function parseDateOnlyAsLocalMidnight(dateString: string): Date {
  const datePart = dateString.split('T')[0];
  const [year, month, day] = datePart.split('-').map(Number);

  if (!year || !month || !day) {
    return new Date(dateString);
  }

  return new Date(year, month - 1, day, 0, 0, 0, 0);
}

export function getTodayLocalMidnight(): Date {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
}

/** Último día en el que el pop-up sigue siendo visible (día anterior al de expiración). */
export function getLastVisibleDate(expiresAt: string): Date {
  const expiresMidnight = parseDateOnlyAsLocalMidnight(expiresAt);
  const lastVisible = new Date(expiresMidnight);
  lastVisible.setDate(lastVisible.getDate() - 1);
  return lastVisible;
}

export function toDateInputValue(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function getMinExpiresAtInputValue(): string {
  return toDateInputValue(getTodayLocalMidnight());
}

/** true si la fecha de expiración (medianoche local) es hoy o posterior. */
export function isExpiresAtDateValid(dateString: string): boolean {
  const selectedDate = parseDateOnlyAsLocalMidnight(dateString);
  const today = getTodayLocalMidnight();
  return selectedDate >= today;
}
